import angular from 'angular';
import soleTraderInfo from './soleTraderInfo';
import './style.scss';

export default angular
  .module('components.soleTraderInfo', [])
  .component('soleTraderInfo', soleTraderInfo).name;
